import React, { Component } from "react";
import cn from "classnames";
import PropTypes from "prop-types";

import EmojiStronglyDisagree from "../../../containers/assets/emoji-strongly-disagree.svg";
import EmojiDisagree from "../../../containers/assets/emoji-disagree.svg";
import EmojiNeutral from "../../../containers/assets/emoji-neutral.svg";
import EmojiAgree from "../../../containers/assets/emoji-agree.svg";
import EmojiStronglyAgree from "../../../containers/assets/emoji-strongly-agree.svg";

const Scale = {
  "Strongly Disagree": 1,
  Disagree: 2,
  Neutral: 3,
  Agree: 4,
  "Strongly Agree": 5
};

class LikertScale extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: props.value
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { id, value } = this.props;

    if (prevProps.id !== id) {
      this.setState(() => ({ selectedValue: value }));
    }
  }

  getEmoji = key => {
    switch (key) {
      case "Strongly Disagree": {
        return EmojiStronglyDisagree;
      }
      case "Disagree": {
        return EmojiDisagree;
      }
      case "Neutral": {
        return EmojiNeutral;
      }
      case "Agree": {
        return EmojiAgree;
      }
      case "Strongly Agree": {
        return EmojiStronglyAgree;
      }
      default:
        break;
    }
  };

  handleOnSelect = value => {
    const { selectedValue } = this.state;
    const { feedback, readonlyMode } = this.props;

    if (readonlyMode) {
      return;
    }

    if (selectedValue !== value) {
      this.setState(
        () => ({ selectedValue: value }),
        () => {
          const { onChange, id } = this.props;

          const hasError = !Object.keys(Scale).find(
            key => Scale[key] === value
          );

          if (onChange)
            onChange({
              id,
              value,
              type: "likert",
              hasError,
              feedback,
            });
        }
      );
    }
  };

  render() {
    const { selectedValue } = this.state;
    const { title, readonlyMode } = this.props;

    return (
      <div className="likertScale">
        <div className="title">{title}</div>
        <div className="likertList">
          {Object.keys(Scale).map((item, index) => (
            <div
              key={`likert-skale-${index}`}
              className={cn("likertContainer", {
                likertContainer_selected: Scale[item] === selectedValue,
                likertContainer_nofocus: readonlyMode,
              })}
              onClick={() => this.handleOnSelect(Scale[item])}
            >
              <img
                alt="emoji"
                className="likertEmoji"
                src={this.getEmoji(item)}
              />
              <div className="likertTitle">{item}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

LikertScale.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  feedback: PropTypes.number,
  readonlyMode: PropTypes.bool,
};

export default LikertScale;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/likert-scale/index.js